"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createTempId;
function createTempId() {
  var num = Math.floor(Math.random() * 2821109907456); // 36^8
  return "tmp_" + Date.now().toString(36) + "_" + num.toString(36);
}


//////////////////
// WEBPACK FOOTER
// ./~/coact/utils/createTempId.js
// module id = 1708
// module chunks = 0